import axios from 'axios'

axios.defaults.withCredentials = true

const capicoHosts = JSON.parse(process.env.VUE_APP_HOSTS)
const capicoHost = capicoHosts[Math.floor(Math.random() * capicoHosts.length)]
// console.log('capico host:', capicoHost)

export default axios.create({
  baseURL: capicoHost,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})
